/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzoliniMutationResponse,
  PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzoliniPathParams,
  PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzoliniQueryParams,
  PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzolini400,
  PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzolini401,
  PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzolini500,
} from "../../types/individualPaymentVanzoliniController/PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzolini.ts";

function getPostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzoliniUrl(
  parcelId: PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzoliniPathParams["parcelId"],
) {
  const res = {
    method: "POST",
    url: `/api/v1/individualpayment/parcels/${parcelId}/take-advantage-vanzolini` as const,
  };
  return res;
}

/**
 * @description Transfere o serial do boleto excedente para a parcela alvo, baixa a parcela, integra a parcela de origem e antecipa a emissão da NF. Migrado do legado IndividualPayment/TakeAdvantageInstallmentVanzolini. **(Requer Authorization para autenticação)**
 * @summary Aproveita um boleto excedente na parcela em aberto (Vanzolini) (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/parcels/:parcelId/take-advantage-vanzolini}
 */
export async function postApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzolini(
  parcelId: PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzoliniPathParams["parcelId"],
  params?: PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzoliniQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzoliniMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzolini400
      | PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzolini401
      | PostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzolini500
    >,
    unknown
  >({
    method: "POST",
    url: getPostApiV1IndividualpaymentParcelsParcelidTakeAdvantageVanzoliniUrl(
      parcelId,
    ).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
